export const en = {
    'page-common-error': 'An error occurred',
    'page-common-error-hint': 'Refresh the page or try again later',
    'save-campaigns-error':
        'Errors occurred while saving the campaign. Try again, and if the error persists, please contact the support service.',
    'warning-about-changes': 'Changes will not be saved. Continue?'
};
